export interface ScreenSize {
  mobile: boolean;
  desktop: boolean;
}

export const screenSize = {
  mobile: false,
  desktop: true,
};
